var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThumbUp2 = function SvgThumbUp2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.823 1.68c2.184.125 2.908 1.767 3.172 2.511.396 1.118-.005 3.328-.005 3.328l4.688.002c.833 0 1.97.75 1.986 1.84.012.873-.407 1.43-.812 1.878.696.62.812 1.264.812 1.934 0 .68-.367 1.383-.863 1.85.025 1.513-.752 2.506-2.112 2.96-.9.3-1.721.365-3.695.365-3.791 0-6.607-2.827-6.662-6.667-.026-1.75.45-3.324 1.397-5.06 1.28-2.347 1.105-3.546 1.113-4.122.005-.428.406-.851.981-.819"
  })));
};
export default SvgThumbUp2;